import { PureComponent } from 'react'
import styled from 'glamorous'
import { noop } from 'lodash'

import { div, $ } from 'utils'
import { VirtualizedSelect } from 'components'


const Container = styled.div({
  display: 'flex',
  alignItems: 'center',
})

const Name = styled.div({
  fontSize: 21,
  fontWeight: 'bold',
  marginRight: 15
})

export class PaginationBar extends PureComponent {

  static defaultProps = {
    onChange: noop,
  }

  render = () => {
    const { name, value, options, onChange, from } = this.props

    return (
      $(Container,
        $(Name, name),
        $(VirtualizedSelect , {
          value,
          options,
          onChange
        }),
        div({style: {marginLeft: 15}}, `from ${from}`)
      )
    )
  }
}

export default PaginationBar



// WEBPACK FOOTER //
// ./src/components/PaginationBar.js